import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { from, Observable, race, Subject, throwError, TimeoutError, timer } from 'rxjs';
import { catchError, finalize, switchMap, tap, timeout } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
@Injectable({
  providedIn: 'root'
})
export class AppInterceptor implements HttpInterceptor {

    constructor(private spinner: NgxSpinnerService, private toastr: ToastrService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Don't display spinner when version check or default delivery method checked (discount by amount)
      if (req.url.startsWith('http') && req.url.indexOf('/assets/') === -1) {
          // this.spinner.show();
          // console.log(req.url);
        const requestFinalized = new Subject();

        if (['POST', 'PUT', 'PATCH'].includes(req.method)) {
          this.spinner.show();
        } else {
          race(requestFinalized.asObservable(), timer(2000).pipe(tap(() => this.spinner.show('longRequest')), switchMap(() => requestFinalized) ))
          .subscribe({
            next: () => this.spinner.hide('longRequest'),
            error: () => this.spinner.hide('longRequest')
          });
        }

        return next.handle(req).pipe(
          //timeout(environment.timeout),
          catchError((timeoutError: TimeoutError) => {
            if (timeoutError?.name === 'TimeoutError') {
                this.toastr.warning('Le serveur est actuellement injoignable ou votre connexion internet est interrompue');
            }
            return throwError(() => timeoutError);
          }),
          catchError((error: HttpErrorResponse) => {
            console.log(error);
            if (error?.status >= 400 && error?.status != 401 && error?.status < 500) {
              if (error?.status === 404 && (error?.error?.type || error.headers.has('content-disposition') && error.headers.get('content-disposition')?.startsWith('attachment'))) {
                this.toastr.warning('Fichier introuvable', undefined);
              } else if (error?.status === 422 && error?.error?.error === 'Duplicate entry') {
                this.toastr.warning(_('Cet enregistrement existe déjà'));
              } else {
                return throwError(() => error);
              }
            }
            // If 401 et que ce n'est pas une demande de login
            if (error?.status === 401 && req.url.indexOf('auth/login') === -1) {
              //TODO vérifier le token
              this.toastr.warning('Cette action ne vous est pas autorisée', 'Non autorisé');
            }

            if (error?.status >= 500) {
              this.toastr.error(
                [502, 504].includes(error?.status) ?
                _('Le service est actuellement indisponible, merci de réessayer ultérieurement') :
                error?.status === 500 ?
                _('Une erreur inattendue s\'est produite, merci de nous contacter si le problème persiste') :
                (error?.error?.message ?? error?.message) );
            }
            this.spinner.hide();
            return throwError(() => error);
          }),
          finalize(() => {
            requestFinalized.next(true);
            this.spinner.hide();
          })
        );
      } else {
        return next.handle(req);
      }
    }
}
